import * as React from 'react';
import { ForwardedRef, forwardRef, useImperativeHandle, useRef } from 'react';

import clsx from 'clsx';

type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, value, ...props }, ref: ForwardedRef<HTMLTextAreaElement>) => {
    const textareaRef = useRef<HTMLTextAreaElement | null>(null);

    useImperativeHandle(ref, () => textareaRef.current!);

    return (
      <textarea
        className={clsx(
          'bg-background placeholder:text-muted-foreground focus-visible:ring-ring overflow-y-auto rounded-md border px-3 py-2 text-sm focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={textareaRef}
        value={value}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
